import React from 'react';
import { useCreateVideo } from './presenter';
import { VideoCreateView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const VideoCreatePage: React.FC<Props> = ({ navigate }) => {
  const vm = useCreateVideo(() => navigate({ name: 'videos/index' as any }));
  const confirm = useConfirm();
  const toast = useToast();
  return (
    <VideoCreateView
      form={vm.form as any}
      setField={vm.setField as any}
      onUpload={vm.uploadFile as any}
      onSubmit={async () => {
        const ok = await confirm({ title: 'Upload Video', message: 'Create this video entry?', confirmText: 'Save' });
        if (!ok) return;
        await vm.submit();
        toast.success('Video created');
      }}
      onCancel={() => navigate({ name: 'videos/index' as any })}
      loading={vm.loading}
      uploading={vm.uploading}
      error={vm.error}
    />
  );
};

export default VideoCreatePage;
